export const DeprecatedQuests = {
    SPIN_THE_WHEEL: 'spinTheWheel',
} as const;

export const Quests = {
    // CORE GAMEPLAY QUESTS
    CLEAR_CARD_ANY: 'clearCardAny',
    CLEAR_CARD_SPADES: 'clearCardSpades',
    CLEAR_CARD_CLUBS: 'clearCardClubs',
    CLEAR_CARD_DIAMONDS: 'clearCardDiamonds',
    CLEAR_CARD_HEARTS: 'clearCardHearts',
    CLEAR_CARD_2: 'clearCard2',
    CLEAR_CARD_3: 'clearCard3',
    CLEAR_CARD_4: 'clearCard4',
    CLEAR_CARD_5: 'clearCard5',
    CLEAR_CARD_6: 'clearCard6',
    CLEAR_CARD_7: 'clearCard7',
    CLEAR_CARD_8: 'clearCard8',
    CLEAR_CARD_9: 'clearCard9',
    CLEAR_CARD_10: 'clearCard10',
    CLEAR_CARD_JACKS: 'clearCardJacks',
    CLEAR_CARD_QUEENS: 'clearCardQueens',
    CLEAR_CARD_KINGS: 'clearCardKings',
    CLEAR_CARD_ACES: 'clearCardAces',
    COMBO_STREAK_BONUS: 'comboStreakBonus',

    // META GAME QUESTS
    COLLECT_STARS: 'collectStars',
    COMPLETE_LEVELS_1ST_TIME: 'completeLevelsFirstTime',
    HARVEST_QUEST: 'harvestQuest',
    PICK_TURNIPS_STAR_CHEST: 'pickTurnipsStarChest',

    // RESOURCE QUESTS
    USE_JOKERS: 'useJokers',
    USE_PLUS_5_CARDS: 'usePlusFiveCards',

    ...DeprecatedQuests
} as const;

export type QuestType = typeof Quests[keyof typeof Quests] | DeprecatedQuestType;
export type DeprecatedQuestType = typeof DeprecatedQuests[keyof typeof DeprecatedQuests];
